import layout from "@/layout";

const examineRouter = {
    path: "/examine",
    name: "examine",
    redirect: {
        name: "examineList"
    },
    component: layout,
    meta: {
        title: "审批"
    },
    children: [
        // 审批列表
        {
            path: "list",
            name: "examineList",
            component: () => import("@/view/examine/examineList"),
            meta: {
                title: "审批列表"
            }
        },
        // 审批流设置
        {
            path: "setting",
            name: "examineSetting",
            component: () => import("@/view/examine/examineSetting"),
            meta: {
                title: "审批流设置"
            }
        }
    ]
};

export default examineRouter;



// WEBPACK FOOTER //
// ./src/router/modules/examineRouter.js